export const LABELS = {
  ACTIONS: {
    NAVIGATE_TO_ORDER: ['pages.customers.view.components.orderList.components.actions.navigateToOrder', 'Open Order Details'],
    COPY_ORDER_ID: ['pages.customers.view.components.orderList.components.actions.copyOrderId', 'Copy Order ID'],
    COPY_USER_EMAIL: ['pages.customers.view.components.orderList.components.actions.copyUserEmail', 'Copy User E-mail'],
  },
};
